import { Button } from '@acies/ui';
import { findGeometryParameter } from '../../../domain/configurations';
import { ConfiguratorModel } from '../configurator.model';
import ShowGeometryDialogButtonEvent from './show-geometry-dialog-button-event';

export default class ShowGeometryDialogButton extends Button {
	public constructor() {
		super();
		// the listener is registered on the model, so it would otherwise run in its scope rather than
		// in this one
		this.parametersChanged = this.parametersChanged.bind(this);
		// Subscribed here rather than on connect, because an Observable tells its listeners about a
		// change and not about the value it already holds.
		ConfiguratorModel.currentParameters.subscribe(this.parametersChanged);
		this.text = 'Geometri';
		this.icon = 'transform';
	}

	protected override initialize(): void {
		super.initialize();
		this.#updateEnabled();
	}

	/**
	 * Unsubscribes, because the model outlives the button.
	 *
	 * `ConfiguratorModel` is a module constant, so a listener it still holds is a button that has been removed and cannot be collected.
	 */
	protected override disconnected(): void {
		super.disconnected();
		ConfiguratorModel.currentParameters.unsubscribe(this.parametersChanged);
	}

	/**
	 * Answers the press with its own event.
	 *
	 * Super.clicked() is deliberately not called: Button answers a press with a ButtonEvent, and a listener above would hear both that and this one, without being able to tell which button the ButtonEvent came from.
	 */
	protected override clicked(): void {
		this.dispatchEvent(new ShowGeometryDialogButtonEvent());
	}

	/** Follows whether the position being worked on has a geometry to change. */
	private parametersChanged(): void {
		this.#updateEnabled();
	}

	/**
	 * Pressable only while there is a geometry parameter.
	 *
	 * Because it is what the dialog changes: without one there is no shape to have picked, and the shapes the dialog would show would be whatever the last position that had one was cut to. Read off the model each time rather than remembered, so it arriving or going settles it the same way.
	 *
	 * Not held back for a drawing, although the dialog shows one. A shape the API refused takes the drawing off the screen — see `ConfiguratorMachine.rejectGeometry` — and the dialog is where another shape is picked, so it has to open without one.
	 */
	#updateEnabled(): void {
		this.enabled = findGeometryParameter(ConfiguratorModel.currentParameters.collection) !== null;
	}
}
customElements.define('ac-show-geometry-dialog-button', ShowGeometryDialogButton);
